module.exports = __webpack_public_path__ + "img/navbar-logo.d8af8962.png";